import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import Paragraph from "../Paragraph";
import './FeaturedCardsFullWidth.scss';
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {fieldObjectSectionStyle} from '../../helpers/graphQLShortcuts';

interface Data {
    paragraphById: {
        fieldObjectSectionStyle: Array<{entity: Array}>;
        fieldSplitItems: Array<{
            targetRevisionId: string
        }>;
    }
}

class FeaturedCardsFullWidthQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentFeaturedCardsFullWd {
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
          fieldSplitItems {
            targetRevisionId
          }
        }
      }
    }
  }
}
`;

const FeaturedCardsFullWidth = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <FeaturedCardsFullWidthQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            // Ensure 2 inner items exist before rendering
            if (!field.fieldSplitItems || field.fieldSplitItems.length < 2) return null;

            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle);

            markComponentLoadedAs(id, true);

            return (
                <React.Fragment>
                    <div className={`featuredCardsFullWidth${styles.classNames}`} style={styles.css} id={styles.id}>
                        {styles.childBackground.isActive && (
                            <div style={styles.childBackground.css}/>
                        )}

                        {field.fieldSplitItems.map(item => (
                            <Paragraph key={`${id}_${item.targetRevisionId}`}
                                       id={String(item.targetRevisionId)}
                                       handleLoadedComponents={handleLoadedComponents}/>
                        ))}

                    </div>
                </React.Fragment>
            );
        }}
    </FeaturedCardsFullWidthQuery>
);

FeaturedCardsFullWidth.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default FeaturedCardsFullWidth;



// WEBPACK FOOTER //
// ./frontend/components/FeaturedCardsFullWidth/FeaturedCardsFullWidth.jsx